const locale = "pt-BR";
const currencyConfigSemSymbol = [locale];

/*
 * Formata o valor numérico, podendo informar o número de casas decimais
 */
export function fn_formatarNumero(valor, decimal) {
  if (!isNaN(valor) && parseFloat(valor)) {
    if (decimal || decimal === 0) {
      return parseFloat(valor).toLocaleString(
        ...[
          locale,
          {
            minimumFractionDigits: decimal,
            maximumFractionDigits: decimal,
          },
        ],
      );
    } else {
      return parseFloat(valor).toLocaleString(...currencyConfigSemSymbol);
    }
  } else {
    if (valor == 0) {
      if (decimal) {
        return "0,00";
      } else {
        return "0";
      }
    } else {
      return "";
    }
  }
}

/*
 * Formata o cep
 */
export function fn_formatarCep(cep) {
  const strCep = String(cep);
  if (strCep && strCep.length == 8) {
    return strCep.substring(0, 5) + "-" + strCep.substring(5);
  } else {
    return cep;
  }
}

/*
 * Formata o telefone
 */
export function fn_formatarTelefone(ddd, numero) {
  if (!ddd || !numero) return "";

  const numeroLimpo = String(numero).replace(/\D/g, "");

  //Se for número de celular (9 dígitos)
  if (numeroLimpo.length === 9) {
    return `(${ddd}) ${numeroLimpo.substring(0, 5)}-${numeroLimpo.substring(
      5,
    )}`;
  }
  //Se for número de telefone fixo (8 dígitos)
  else if (numeroLimpo.length === 8) {
    return `(${ddd}) ${numeroLimpo.substring(0, 4)}-${numeroLimpo.substring(
      4,
    )}`;
  }

  return "";
}

/*
 * Formata um valor que pode ser CNPJ ou CPF
 */
export function fn_formatarCnpjCpf(valor) {
  if (!valor) return "";

  //Se tiver 11 ou menos dígitos considera que é CPF
  if (valor.length <= 11) {
    valor = valor.padStart(11, "0");
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }

  //Se tiver entre 11 e 14 dígitos considera que é CNPJ
  if (valor.length > 11 && valor.length <= 14) {
    valor = valor.padStart(14, "0");
    return valor.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
      "$1.$2.$3/$4-$5",
    );
  }

  return valor;
}

/*
 * Formata o total de segundos em HH:mm:ss
 */
export function fn_formatarTempo(seconds) {
  const hrs = String(Math.floor(seconds / 3600)).padStart(2, "0");
  const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
  const secs = String(seconds % 60).padStart(2, "0");
  return `${hrs}:${mins}:${secs}`;
}

/*
 * Remove a formatação do valor
 */
export function fn_removerFormatacao(valor) {
  if (!valor) return null;

  if (typeof valor !== "string") {
    valor = String(valor);
  }

  //return valor.replace(/[.,\-(){}\[\]/\\\s]/g, "");
  return valor.replace(/[.,(){}[\]/\\\s-]/g, "");
}

/*
 * Remove caracteres inválidos para nome de arquivo
 */
export function fn_removerCaracteresInvalidosNomeArquivo(nome) {
  return nome.replace(/[\\/:*?"<>|]/g, "");
}

/*
 * Remover quebra de linha no texto.
 * Utilizado nos campos textarea para não ocorrer problema com geração de csv
 */
export function fn_removerQuebraLinha(valor) {
  return typeof valor == "string"
    ? valor.replace(/[\r\n]+/g, " ").trim()
    : valor;
}

/*
 * Transforma o valor monetário de string para número
 */
export function fn_parseValorMonetario(valor) {
  if (!valor) return 0;
  return Number(String(valor).replace(/\./g, "").replace(",", "."));
}

/*
 * Transforma o valor percentual de string para número
 */
export function fn_parseValorPercent(valor) {
  if (!valor) return 0;
  return Number(String(valor).replace(",", "."));
}

/*
 * Retorna apenas os números de um valor string
 */
export function fn_extrairValorNumerico(valor) {
  if (typeof valor !== "string") return "";
  return valor.replace(/\D/g, "");
}

/*
 * Retorna a primeira palavra do texto
 */
export function fn_extrairPrimeiraPalavra(texto) {
  return texto.split(" ")[0];
}

/*
 * Retorna o ddd e numero de telefone de um valor de telefone formatado (Ex: (41) 9876-6745)
 */
export function fn_extrairDddNumeroTelefone(telefone) {
  if (!telefone) {
    return { ddd: null, numero: null };
  }

  // Remove tudo que não for número
  const numeros = telefone.replace(/\D/g, "");

  // Telefone brasileiro precisa ter pelo menos DDD + número
  if (numeros.length < 10) {
    return { ddd: null, numero: null };
  }

  const ddd = numeros.slice(0, 2);
  const numero = numeros.slice(2);

  return {
    ddd,
    numero,
  };
}

/*
 * Verifica se o valor é um número válido
 */
export function fn_isValidNumber(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
}

/*
 * Valida o formato do e-mail
 */
export function fn_validarEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

/*
 * Valida o formato do telefone
 */
export function fn_validarTelefone(telefone) {
  const telefoneRegex = /^\([1-9]{2}\)\s(?:\d{4}-\d{4}|\d{5}-\d{4})$/;
  return telefoneRegex.test(telefone);
}

/*
 * Valida o formato do cep
 */
export function fn_validarCep(cep) {
  const cepRegex = /^[0-9]{8}$/;
  return cepRegex.test(cep);
}

/*
 * Valida o CPF
 */
export function fn_validarCpf(valor) {
  if (!valor || typeof valor !== "string") return false;

  //Garante apenas números
  const doc = valor.replace(/\D/g, "");

  //Rejeita sequências iguais
  if (/^(\d)\1+$/.test(doc)) return false;

  if (doc.length === 11) {
    let soma = 0;

    for (let i = 0; i < 9; i++) {
      soma += Number(doc[i]) * (10 - i);
    }

    let dig1 = (soma * 10) % 11;
    dig1 = dig1 === 10 ? 0 : dig1;

    if (dig1 !== Number(doc[9])) return false;

    soma = 0;
    for (let i = 0; i < 10; i++) {
      soma += Number(doc[i]) * (11 - i);
    }

    let dig2 = (soma * 10) % 11;
    dig2 = dig2 === 10 ? 0 : dig2;

    return dig2 === Number(doc[10]);
  }

  //tamanho inválido
  return false;
}

/*
 * Valida o CNPJ
 */
export function fn_validarCnpj(valor) {
  if (!valor || typeof valor !== "string") return false;

  //Garante apenas números
  const doc = valor.replace(/\D/g, "");

  //Rejeita sequências iguais
  if (/^(\d)\1+$/.test(doc)) return false;

  if (doc.length === 14) {
    const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const pesos2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    let soma = 0;
    for (let i = 0; i < 12; i++) {
      soma += Number(doc[i]) * pesos1[i];
    }

    let dig1 = soma % 11;
    dig1 = dig1 < 2 ? 0 : 11 - dig1;

    if (dig1 !== Number(doc[12])) return false;

    soma = 0;
    for (let i = 0; i < 13; i++) {
      soma += Number(doc[i]) * pesos2[i];
    }

    let dig2 = soma % 11;
    dig2 = dig2 < 2 ? 0 : 11 - dig2;

    return dig2 === Number(doc[13]);
  }

  //tamanho inválido
  return false;
}

/*
 * Retorna a raiz do CNPJ
 */
export function fn_extrairRaizCNPJ(cnpj) {
  return String(cnpj).replace(/\D/g, "").slice(0, 8);
}

/*
 * Verifica se a raiz de dois cnpjs são iguais, para validar se o CNPJ da filial pertence à empresa
 * O CNPJ pode ou não estar formatado. Ex: 79.571.407/0001-29. A raiz é 79571407
 */
export function fn_validarRaizCNPJ(cnpj1, cnpj2) {
  if (!cnpj1 || !cnpj2) return false;

  //Extrai a raiz do CNPJ (8 primeiros dígitos, removendo formatação)
  const raizCNPJ1 = String(cnpj1).replace(/\D/g, "").slice(0, 8);
  const raizCNPJ2 = String(cnpj2).replace(/\D/g, "").slice(0, 8);

  return raizCNPJ1 === raizCNPJ2;
}

/*
 * Calcula o DV da base de um CNPJ
 */
export function fn_calcularDVCNPJ(cnpjBase) {
  // Remove tudo que não for número
  const cnpj = String(cnpjBase).replace(/\D/g, "");

  if (cnpj.length !== 12) {
    throw new Error("CNPJ base deve ter 12 dígitos (sem os DVs)");
  }

  const calcularDV = (base, pesos) => {
    const soma = base
      .split("")
      .reduce((acc, num, i) => acc + Number(num) * pesos[i], 0);

    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  };

  // Pesos
  const pesosDV1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const pesosDV2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  const dv1 = calcularDV(cnpj, pesosDV1);
  const dv2 = calcularDV(cnpj + dv1, pesosDV2);

  return `${dv1}${dv2}`;
}

/*
 * Valida o formato da data
 */
export function fn_validarFormatoData(data, formato) {
  const dataRegex = getRegexFormatoData(formato);
  return dataRegex.test(data);
}

/*
 * Retorna a expressão regular do formato de data passado como parâmetro
 */
function getRegexFormatoData(formatoData) {
  // Substitui caracteres de formato por suas representações regex
  const regex = formatoData
    .replace(/YYYY/g, "\\d{4}")
    .replace(/MM/g, "\\d{2}")
    .replace(/DD/g, "\\d{2}")
    .replace(/HH/g, "\\d{2}")
    .replace(/mm/g, "\\d{2}")
    .replace(/ss/g, "\\d{2}")
    //.replace(/[-\/\s:]/g, "\\$&"); // Qualquer caractere de formatação literal (como hífens, barras, espaços) é precedido por \
    .replace(/[-/\s:]/g, "\\$&"); // Qualquer caractere de formatação literal (como hífens, barras, espaços) é precedido por \
  return new RegExp(`^${regex}$`);
}

/*
 * Valida se a cor está em hexadecimal
 */
export function fn_validarCorHexa(color) {
  const corRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
  return corRegex.test(color);
}

/*
 * Valida se o valor do campo possui espaço em branco
 */
export function fn_validarCampoEspacoBranco(valorCampo) {
  const regex = /^[^\s]+$/; // Não permite espaços em branco
  return regex.test(valorCampo);
}

/*
 * Retorna o texto retirando acentuação das palavras
 */
export function fn_removerAcentuacao(texto) {
  if (!texto) return "";

  return texto
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .replace(/[´`^~]/g, "")
    .replace(/ç/g, "c");
}

/*
 * Retorna a palavra passada como parâmetro com a primeira letra em maiúsculo.
 */
export function fn_capitalizarPalavra(palavra) {
  if (!palavra) return "";
  return palavra.charAt(0).toUpperCase() + palavra.slice(1).toLowerCase();
}

/*
 * Codifica valores que possuem algum caracter especial para passar na url.
 * Ex: Datas. A barra é codificada para "%2F"
 * Obs.: Se for utilizado framework como Express, Koa, Hapi, Fastify, etc. não há necessidade de decodificar no servidor, pois o framework já faz isso
 */
export function fn_url_codificarValor(valor) {
  try {
    //Tenta decodificar o valor. Se não mudar, significa que não está codificado.
    if (decodeURIComponent(valor) === valor) {
      return encodeURIComponent(valor);
    }
  } catch {
    //Se ocorrer erro na decodificação, significa que não está codificado
    return encodeURIComponent(valor);
  }
  return valor; //Retorna o valor original se ele já estiver codificado
}

/*
 * Decodifica valores que foram codificados.
 */
export function fn_url_decodificarValor(valor) {
  try {
    return decodeURIComponent(valor);
  } catch {
    return valor;
  }
}

/*
 * Gera um delay em milissegundos. Se não passar o valor será de 500ms
 */
export async function fn_delay(ms = 500) {
  return new Promise((res) => setTimeout(res, ms));
}

/*
 * Transforma um valor string boolean em valor boolean
 */
export function fn_toBoolean(value) {
  return ["true", "s", "1"].includes(String(value).toLowerCase());
}

/*
 * Verifica se o objeto está vazio
 */
export function fn_isEmpty(obj) {
  // null / undefined
  if (obj == null) return true;

  // se não for objeto (string, number, boolean, function, etc.) → não é vazio
  if (typeof obj !== "object") return false;

  // Se for instância (Sequelize model, etc.) converte para plain object se possível
  if (typeof obj.toJSON === "function") {
    try {
      obj = obj.toJSON();
    } catch {
      // se falhar, segue com o original
    }
  }

  // Array vazio
  if (Array.isArray(obj)) return obj.length === 0;

  // Map/Set vazios
  if (obj instanceof Map || obj instanceof Set) return obj.size === 0;

  // Verifica chaves próprias enumeráveis e símbolos
  if (
    Object.keys(obj).length === 0 &&
    Object.getOwnPropertySymbols(obj).length === 0
  ) {
    // ainda pode ter propriedades não-enumeráveis — vamos inspecionar own property names
    const allProps = Object.getOwnPropertyNames(obj);
    return allProps.length === 0;
  }

  return false;
}

//Nao está usando no SIIG por enquanto
// export function fn_mapBodyToModel(body, model) {
//   const result = {};

//   let fields = [];

//   // Tentativa de extrair atributos de Model Sequelize
//   if (model.constructor?.rawAttributes) {
//     fields = Object.keys(model.constructor.rawAttributes);
//   } else {
//     // Caso comum → pega todas as chaves do objeto
//     fields = Object.keys(model);
//   }

//   // fields.forEach((field) => {
//   //   if (body.hasOwnProperty(field)) {
//   //     result[field] = body[field];
//   //   }
//   // });
//   fields.forEach((field) => {
//     if (Object.prototype.hasOwnProperty.call(body, field)) {
//       result[field] = body[field];
//     }
//   });

//   return result;
// }

/*
 * Converte o tempo da sessão em minutos.
 * Ex: "30m" = 30; "12h" = 720; "1d" = 1440; "45" = 45, 20 = 20
 */
export function fn_converterTempoSessaoParaMinutos(tempo) {
  if (typeof tempo === "number") return tempo;

  const regex = /^(\d+)([mhd]?)$/i;
  const match = regex.exec(tempo);

  if (!match) {
    throw new Error(`Formato inválido de tempo de sessão: ${tempo}`);
  }

  const valor = Number(match[1]);
  const unidade = match[2].toLowerCase();

  switch (unidade) {
    case "h":
      return valor * 60;
    case "d":
      return valor * 60 * 24;
    case "m":
    case "":
      return valor;
    default:
      throw new Error(`Unidade de tempo inválida: ${unidade}`);
  }
}

/*
 * Verifica se a string está em format JSON.
 */
export function fn_isJSONString(str) {
  try {
    JSON.parse(str);
    return true;
  } catch {
    return false;
  }
}

/*
 * Retorna um número randômico entre um valor mínimo e máximo.
 * Se o parâmetro decimal for podendo retornar com casa decimal
 */
export function fn_gerarNumero(min, max, decimal) {
  if (decimal) {
    const random = Math.random() * (Number(max) - Number(min)) + Number(min);
    return Number(random.toFixed(decimal));
  } else {
    return (
      Math.floor(Math.random() * (Number(max) - Number(min) + 1)) + Number(min)
    );
  }
}

/*
 * Retrona a chave que possui maior valor em uma lista de [key] = valor
 */
export function fn_getChaveMaiorValor(valores = {}) {
  let chaveMaiorValor = null;
  let maiorValor = -Infinity;

  for (const [chave, valor] of Object.entries(valores)) {
    const numValor = Number(valor);

    if (numValor > maiorValor) {
      maiorValor = numValor;
      chaveMaiorValor = chave;
    }
  }

  return chaveMaiorValor;
}

/*
 * Retorna a soma dos valores contidos em um list simples que pode ser um array ou um objeto simples
 * contendo valores numéricos
 */
export function fn_calcularTotal(list, nomeCampo) {
  if (!list) return 0;

  if (Array.isArray(list)) {
    if (nomeCampo) {
      return list.reduce((acc, cur) => acc + Number(cur[nomeCampo] || 0), 0);
    } else {
      return list.reduce((acc, cur) => acc + Number(cur || 0), 0);
    }
  } else {
    if (nomeCampo) {
      return Object.values(list).reduce(
        (acc, cur) => acc + Number(cur[nomeCampo] || 0),
        0,
      );
    } else {
      return Object.values(list).reduce(
        (acc, cur) => acc + Number(cur || 0),
        0,
      );
    }
  }
}

/*
 * Retorna a soma dos valores de determinado campo, agrupados por um ou mais campos
 */
export function fn_agruparTotal(list, camposKey = [], campoTotal) {
  if (!list) return {};

  return list.reduce((acc, item) => {
    const data = item?.dataValues ?? item;
    let nivelAtual = acc;

    //Percorre cada nível do agrupamento
    camposKey.forEach((campo, index) => {
      const key = fn_getValorPath(data, campo); //data[campo];

      // Se é o último nível → acumula
      if (index === camposKey.length - 1) {
        if (!nivelAtual[key]) {
          nivelAtual[key] = 0;
        }
        nivelAtual[key] += Number(data[campoTotal]);
      }
      // Caso contrário → cria o objeto e desce um nível
      else {
        if (!nivelAtual[key]) {
          nivelAtual[key] = {};
        }
        nivelAtual = nivelAtual[key];
      }
    });

    return acc;
  }, {});
}

/*
 * Retorna o valor do campo, podendo passar campo de objeto dentro de outro objeto
 * Ex: filial.id_centro_custo
 */
export function fn_getValorPath(obj, path, defaultValue = "") {
  return (
    path
      .split(".")
      .reduce(
        (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
        obj,
      ) ?? defaultValue
  );
}

/*
 * Retorna a soma dos valores de determinados campos de objetos dentro de uma lista.
 */
export function fn_getTotaisCamposResult(result, campos = []) {
  let totais = {};

  if (result && result.length > 0) {
    totais = result.reduce((acc, item) => {
      Object.keys(item).forEach((key) => {
        if (campos.includes(key)) {
          const value = item[key];

          if (fn_isValidNumber(value)) {
            acc[key] =
              (Number(acc[key]) || 0) +
              (fn_isValidNumber(value) ? Number(value) : 0);
          }
        }
      });

      return acc;
    }, {});
  }
  return totais;
}

/*
 * Remove campos do objeto
 */
export function fn_removerCampos(obj, camposExcecao = []) {
  if (!camposExcecao.length) return obj;

  return Object.fromEntries(
    Object.entries(obj).filter(([key]) => !camposExcecao.includes(key)),
  );
}

//Se o valor não for um array, retorna ele dentro de um array
export function fn_getArray(valor) {
  return valor ? (Array.isArray(valor) ? valor : [valor]) : [];
}
